import { createClient } from '@supabase/supabase-js';

// Use a URL básica do projeto, SEM o sufixo "/storage/v1/s3"
const supabaseUrl = 'https://saedktkugjhbgyufotkz.storage.supabase.co';
const supabaseAnonKey = 'sb_publishable_ecUBZPa63bxi8xNJJzZMMw_hyEea65Q'; 

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
